import React, {useRef, useState} from "react";
import axios from "axios";
import VehicleJobSection from "../Job/VehicleJobSection";
import {ToastContainer, toast} from "react-toastify";
import { Box, Button, Column, Columns, Control, Field, Input, Select, Table, Title } from "@allxsmith/bestax-bulma";
import shortid from "shortid";
import WorkSection from "./WorkSection";
import ContactSection from "../Contact/ContactSection";
import {
  createSetQuoteAction,
  createSetQuoteFieldAction
} from "../../actions/dataActions";
import {useDispatch, useSelector} from "react-redux";
import {
  getAppDefaultsData,
  getDataFresh,
  getExistingJobsData,
  getImagesData, getInspectionData,
  getQuoteData,
  getWorkTypeData
} from "../../state/selectors";
import Validator from "./Validator";
import {useReactToPrint} from "react-to-print";
import PartSearchModal from "../Job/PartSearchModal";
import {getPartCustomerCost, getPartCustomerEstimatedCost, readableDate,} from "../../utils";
import useSafeSave from "../../hooks/useSafeSave";
import CreateJobCardModal from "./CreateJobCardModal";
import NotReadyForInvoiceModal from "./NotReadyForInvoiceModal";
import DeleteWarningModal from "../Modal/DeleteWarningModal";
import TopSummary from "../Job/TopSummary";
import PrintOptionsModal from "./PrintOptionsModal";
import FinalizeModal from "./FinalizeModal";
import ApprovalModal from "../Job/ApprovalModal";
import Comment from "../Job/Comment";
import WorkSearchModal from "../Job/WorkSearchModal";
import QuoteTypeSelector from "./QuoteTypeSelector";
import PrintPickList from "./PrintPickList";
import DefectJobSection from "../Job/Defects/DefectJobSection";
import PartEnquiryJobSection from "../Job/Part Enquiry/PartEnquiryJobSection";
import ImageModal from "../Job/ImageModal";
import {useImagesData} from "../../hooks/useImagesData";
import VehicleInspectionRow from "../Job/VehicleInspectionRow";
import {useExistingJobData} from "../../hooks/useExistingJobData";
import {useVehicleInspectionData} from "../../hooks/useVehicleInspectionData";

function QuoteForm(props) {
  const printPickListRef = useRef();

  const handlePickListPrint = useReactToPrint({contentRef: printPickListRef});

  const dateFields = ["provisional_start_date", "customer1_invoice_date", "customer2_invoice_date"];
  const [lastChange, setLastChange] = useState();
  const dispatch = useDispatch();
  let quote = useSelector(getQuoteData);
  let appDefaults = useSelector(getAppDefaultsData);
  let workTypes = useSelector(getWorkTypeData);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  let dataFresh = useSelector(getDataFresh);

  let imageParams = {type: "quote"}
  let existingJobsParams = {};
  if(quote && quote.vehicle){
        imageParams.blob_name = quote.vehicle.registration+"-"+quote.id;
        imageParams.id = quote.id
        existingJobsParams.vehicle = quote.vehicle.id
  }
  let imagesLoaded = useImagesData(imageParams, dataFresh);
  let images = useSelector(getImagesData);
  let existingJobsLoaded = useExistingJobData(existingJobsParams);
  let existingJobs = useSelector(getExistingJobsData);



  // quote.estimated_work_items = quote.estimated_work_items.map(
  //   (item, index) => {
  //     return {...item, index};
  //   }
  // );

  const [partsModalState, setPartsModalState] = useState({
    modalOpen: false,
    currentSearch: "",
    searchText: "",
    partIndex: 0,
    workIndex: 0
  });


  const [workModalState, setWorkModalState] = useState({
    modalOpen: false,
    currentSearch: "",
    searchText: "",
    workIndex: 0
  });

  const [createJobCardModalState, setCreateJobModalState] = useState({
    modalOpen: false
  });

  const [notReadyModalOpen, setNotReadyModalOpen] = useState(false);
  const [notReadyItems, setNotReadyItems] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [finalizeModalOpen, setFinalizeModalOpen] = useState(false);
  const [printOptionsModalOpen, setPrintOptionsModalOpen] = useState(false);

  const onClick = item => {
    let editUrl = item.itemType === "Job" ? "editjob" : "editquote";
    window.open(`/${editUrl}/${item.id}`, "_self");
  };

  const addWorkItem = () => {
    triggerChange({
      estimated_work_items: quote.estimated_work_items.concat({
        key: shortid.generate(),
        chargeable: !!quote.customer2,
        estimated_labour_cost: 0,
        estimated_customer_labour_cost: 0,
        estimated_labour_hours: 0,
        customer_labour_cost: 0,
        labour_cost: 0,
        labour_hours: 0,
        parts: [],
        quote: quote.id || undefined
      })
    });
  };

  const addComment = e => {
    e.preventDefault();
    triggerChange({
      comments_list: quote.comments_list.concat({
        key: shortid.generate(),
        text: "",
        quote: quote.id || undefined
      })
    })
  };


  const finalize = () => {
    const endpoint = props.endpoint + "quotes/finalize/" + quote.id;
    const conf = {
      method: "post",
      url: endpoint
    };
    axios(conf).then(response =>
      dispatch(createSetQuoteAction(response.data))
    );
  };

  const handleFinalize = e => {
    safeSave()
      .then(finalize)
      .catch(reason => {
        toast.error("Unable to finalize Quote", {position: "top-right"});
      });
  };

  const approveForInvoice = () => {
    let fails = quote.estimated_work_items.filter(item => item.not_being_done === false).filter(item => {
      return !checkWorkItemIsInvoiceReady(item);
    });

    if (fails.length > 0) {
      setNotReadyItems(fails);
      setNotReadyModalOpen(true);
    } else {
      const endpoint = props.endpoint + "quotes/approve/" + quote.id;
      const conf = {
        method: "post",
        url: endpoint
      };
      axios(conf).then(response =>
        dispatch(createSetQuoteAction(response.data))
      );
    }
  };

  const handleApproveForInvoice = () => {
    safeSave()
      .then(approveForInvoice)
      .catch(reason => {
        console.log(reason)
        toast.error("Unable to approve Quote", {position: "top-right"});
      });
  };

  const checkWorkItemIsInvoiceReady = workItem => {
    // if the quote is a duplicate we should let it go through to invoicing always
    if(!quote.duplicate) {
      if (!workItem.work_type || !workItem.job || !workItem.job_approved) {
        return false;
      }
      if (workItem.work_type && workItem.work_type.free_of_charge && workItem.work_type.approval_needed && !workItem.approval_received) {
        return false;
      }
      if (!workItem.work_type.free_of_charge && !workItem.job_workshop_invoice_number) {
        return false;
      }

      for (let i = 0; i < workItem.parts.length; i++) {
        if (
            !workItem.parts[i].part_invoice_number &&
            !workItem.parts[i].from_stock &&
            !workItem.parts[i].backorder &&
            !workItem.parts[i].backorder_expected_date
        ) {
          return false;
        }
      }
      return true;
    }
    else{
      return true;
    }
  };

  const checkNotUpdated = () => {
    if (quote.id) {
      return axios
        .get(props.endpoint + "quotes/" + quote.id)
        .then(
          result =>
            (new Date(result.data.last_saved).getTime() -
              new Date(quote.last_saved).getTime()) /
            1000 <
            1
        );
    }
    return new Promise((res, rej) => res(true));
  };

  const searchSelectPart = (part, partIndex, workIndex) => {
    let newWorkItem = quote.estimated_work_items[workIndex];
    let customer = newWorkItem.chargeable
      ? quote.customer2
      : quote.customer;

    let newPart = {
      name: part.name,
      part_number: part.part_number,
      supplier: part.supplier,
      cost: part.cost,
      estimated_cost: part.cost,
      estimated_customer_cost: getPartCustomerCost(part, customer, appDefaults),
      customer_cost: getPartCustomerCost(part, customer, appDefaults),
      created_from_lookup: part.id
    };

    newWorkItem.parts[partIndex] = {
      ...newWorkItem.parts[partIndex],
      ...newPart
    };

    updateWork(newWorkItem, workIndex);
    setPartsModalState({...partsModalState, modalOpen: false});
  };

  const partLookupToParts = (lookup) => {
    let part = {
      part_number: lookup.part_number,
      estimated_cost: lookup.cost,
      supplier: lookup.supplier,
      name: lookup.name,
    }

    part.estimated_customer_cost = getPartCustomerEstimatedCost(part, quote.customer2 ? quote.customer2 : quote.customer, appDefaults);
    part.customer_cost = part.estimated_customer_cost;
    part.cost = part.estimated_cost;

    return part;
  }

  const searchSelectWork = (work) => {
    let parts = [];
    work.part_work_lookup.map(part => {
      parts.push(partLookupToParts(part))
    });

    let newWorkItem = {
      key: shortid.generate(),
      description: work.description,
      chargeable: !!quote.customer2,
      labour_cost: 0,
      estimated_labour_cost: work.labour_cost,
      customer_labour_cost: 0,
      estimated_customer_labour_cost: work.customer_labour_cost,
      labour_hours: 0,
      estimated_labour_hours: work.labour_hours,
      parts: parts,
      cost_override: true,
      quote: quote.id || undefined
    };
    triggerChange({
      estimated_work_items: quote.estimated_work_items.concat(newWorkItem)
    });
    setWorkModalState({...workModalState, modalOpen: false});
  };

  const onSearchPartClick = (part, partIndex, workIndex) => {
    const searchText = [
      quote.vehicle ? quote.vehicle.make ? quote.vehicle.make.name : "" : "",
      quote.vehicle ? quote.vehicle.model ? quote.vehicle.model.name : "" : "",
      quote.vehicle.type ? quote.vehicle.type.name : "",
      part.name
    ].join(" ");

    setPartsModalState({
      modalOpen: true,
      currentSearch: searchText,
      workIndex,
      partIndex,
      searchText
    });
  };
  const triggerChange = data => {
    makeDirty();
    setLastChange(new Date());
    dispatch(createSetQuoteFieldAction(data));
  };

  const onCheck = e => {
      const toUpdate = {
          [e.target.name]: !quote[e.target.name]
      };
      triggerChange(toUpdate);
  }


  const getWorkIndex = (id, items) => {
    //  items is an array  of objects
    if (!id || !items){
      return -1
    }
    let index = 0;
    let target = -1;
    items.forEach(item => {
      if(item.id === id) {
        target =  index
      }
      index += 1;
    });
    return target
  }

  const updateWork = (work) => {
    let newWorkItems = [...quote.estimated_work_items];
    let index = getWorkIndex(work.id, newWorkItems);
    if(index !== -1) {
      newWorkItems.splice(index, 1, work);
      triggerChange({estimated_work_items: newWorkItems});
    }
    else  if(index === -1){
      // check if the work item has an id, if it doesnt then its the last item in the array
      if(!work.id){
        index = newWorkItems.length -1; // length doesnt count from 0
        newWorkItems.splice(index, 1, work);
        triggerChange({estimated_work_items: newWorkItems});
      }
    }
    else{
      toast.warning("Something went wrong")
    }
  };

  const removeWorkItem = (index, work) => {
    if (!work.work) {
      let newWorkItems = [...quote.estimated_work_items];
      newWorkItems.splice(index, 1);
      triggerChange({estimated_work_items: newWorkItems});
    } else {
      toast.error("This item is linked to a job card. You must delete the work item on the job card first!", {position: "top-right"});
    }
  };

  const updateComment = (comment, index) => {
    let newComments = [...quote.comments_list];
    newComments.splice(index, 1, comment);
    triggerChange({comments_list: newComments});
  };

  const removeComment = index => {
    let newComments = [...quote.comments_list];
    newComments.splice(index, 1);
    triggerChange({comments_list: newComments});
  };


  const handleChange = e => {
    const {name, value} = e.target;
    triggerChange({[name]: value});
  };

  const handleUpdateHireCustomer = e => {
    triggerChange({customer2: e});
    if (!e) {
      let newWorkItems = quote.estimated_work_items.map(item => {
        return {...item, chargeable: false};
      });
      triggerChange({estimated_work_items: newWorkItems});
    }
  };

  const fixEmptyDates = quote => {
    let newQuote = {...quote}
    dateFields.forEach(function (date) {
      if (newQuote[date] === "") {
        newQuote[date] = null;
      }
    });
    let work_items = [...newQuote.estimated_work_items];
    newQuote.estimated_work_items = work_items.map(work => {
      let newWork =  {...work}
      let parts = [...newWork.parts];
      newWork.parts = parts.map(part => {
        let newPart = {...part}
        if (newPart.date_ordered === "") {
          newPart.date_ordered = null;
        }
        if (newPart.backorder_expected_date === "") {
          newPart.backorder_expected_date = null;
        }
        return newPart;
      });
      return newWork;
    });
    return newQuote;
  };

  const handleSave = e => {
    e.preventDefault();
    safeSave();
  };

  const save = () => {
    let quoteToSave = fixEmptyDates(quote);
    const endpoint = quoteToSave.id
      ? props.endpoint + "quotes/" + quoteToSave.id
      : props.endpoint + "createquote";
    const method = quoteToSave.id ? "put" : "post";

    const conf = {
      method: method,
      data: quoteToSave,
      url: endpoint
    };
    return axios(conf).then(resp => {
      dispatch(createSetQuoteAction(resp.data));
      if (!quoteToSave.id) {
        window.open("/editquote/" + resp.data.id, "_self");
      }
    }).catch(err => {
      console.log(err)
      toast.error("There was an error when saving the quote", {position: "top-right"})
    });
  };

  const [makeDirty, safeSave] = useSafeSave(
    save,
    lastChange,
    () => Validator(quote),
    checkNotUpdated
  );

  const handleDelete = e => {
    e.preventDefault();
    const endpoint = props.endpoint + "quotes/" + quote.id;
    const conf = {method: "delete", url: endpoint};
    axios(conf).then(response => window.open("/quotes", "_self"));
  };

  if (props.loaded) {
     const departmentObjects = props.departments && props.departments.results.reduce((obj, item) => {
      return {
        ...obj,
        [item["id"]]: item
      };
    }, {});
     const workTypeObjects = workTypes && workTypes.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {});

     // only once departments are loaded - otherwise this loops setting undefined (React #301)
     if(!quote.department && Object.keys(departmentObjects).length){
       triggerChange({department: Object.values(departmentObjects)[0]})
     }
    const onDepartmentsChange = (e) => {
      const data = departmentObjects[e.target.value];
      triggerChange({department: data});
    };
    const onQuoteTypeChange = (e) =>{
      triggerChange({quote_type: e.target.value})
    }
    document.title = "Quote - " + (quote.vehicle && quote.vehicle.registration ? quote.vehicle.registration : "New");

    return (
      <div>
        <TopSummary
          quote={true}
          job={quote}
          customer_label={
            quote.customer ? quote.customer.display_name : "Customer"
          }
          customer2_label={
            quote.customer2
              ? quote.customer2.display_name
              : "Customer 2"
          }
          onSave={handleSave}
          itemType="Quote"
          handleChange={handleChange}
        ></TopSummary>
        <br/>
        <br/>
        <br/>
        <br/>
        <VehicleJobSection
          handleVehicleChange={vehicle => triggerChange({vehicle})}
          customerVehicle={quote.customer_vehicle}
          vehicleUpdate={vehicle => triggerChange({vehicle})}
          endpoint={props.endpoint}
          vehicle={quote.vehicle ? quote.vehicle : {}}
          history={props.history}
          type={"Quote"}
          disabled={quote.id}
        />
        <Columns isMultiline>
          <Column>
            <ContactSection
              title="Customer"
              contactUpdate={customer => triggerChange({customer})}
              endpoint={props.endpoint + "contacts"}
              contact={quote.customer || {}}
              disabled={quote.customer_invoice_number}
              type="CC"
              displayWorkshopInstructions
              department={quote.department}
            />
          </Column>
          <Column>
            <ContactSection
              title="Customer 2"
              contactUpdate={handleUpdateHireCustomer}
              endpoint={props.endpoint + "contacts"}
              contact={quote.customer2 || {}}
              type="CC"
              disabled={quote.customer2_invoice_number}
              displayWorkshopInstructions
              department={quote.department}
            />
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <DefectJobSection
              disabled={true}
              job={quote}
            />
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <PartEnquiryJobSection
              disabled={true}
              job={quote}
            />
          </Column>
        </Columns>
        <Box>
          <h1 className="title">Quote Info</h1>
          {(images && images.length > 0) &&
            <Columns isMultiline>
              <Column>
                <p className={"bold"}>This Quote Has Attached Files</p>
              </Column>
            </Columns>
          }
          <form>
            <Columns isMultiline>
              <Column>
                <Field>
                  <label className="label">Department</label>
                  <Control>
                    <Select name='department' value={quote.department ? quote.department.id : 0} onChange={onDepartmentsChange}>
                      {props.departments.results.map(item => (
                        <option key={item.name} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </Select>
                  </Control>
                </Field>
              </Column>
              <Column>
                <QuoteTypeSelector
                  selectedtype={quote.quote_type}
                  onChange={onQuoteTypeChange}
                />
              </Column>
              {quote.duplicate &&
              <Column>
                <label className="label">Off Hire Date</label>
                <Input
                  type={"date"}
                  value={quote.off_hire_date}
                  onChange={handleChange}
                  name={"off_hire_date"}
                />
              </Column>
              }
            </Columns>
            <Columns isMultiline>
              <Column>
                <Field>
                  <label className="label">Quote Description</label>
                  <Control>
                    <Input
                      type="text"
                      name="description"
                      onChange={handleChange}
                      value={quote.description}
                      required
                    />
                  </Control>
                </Field>
              </Column>
            </Columns>
            <Columns isMultiline>
              <Column>
                <Field>
                  <label className="label">Provisional Start Date</label>
                  <Control>
                    <Input
                      type="date"
                      name="provisional_start_date"
                      onChange={handleChange}
                      value={quote.provisional_start_date || ""}
                      required
                    />
                  </Control>
                </Field>
              </Column>
              <Column>
                <Field>
                  <label className="label">Quote Created Date</label>
                  <Control>
                    <Input
                      type="date"
                      name="date_created"
                      value={quote.date_created || ""}
                      disabled
                      readOnly
                    />
                  </Control>
                </Field>
              </Column>
              <Column>
                <Field>
                  <label className="label">Customer 1 Invoice Number</label>
                  <Control>
                    <Input
                      type="text"
                      name="customer_invoice_number"
                      onChange={handleChange}
                      value={quote.customer_invoice_number}
                    />
                  </Control>
                </Field>
              </Column>
              <Column>
                <Field>
                  <label className="label">Customer 2 Invoice Number</label>
                  <Control>
                    <Input
                      type="text"
                      name="customer2_invoice_number"
                      onChange={handleChange}
                      value={quote.customer2_invoice_number}
                    />
                  </Control>
                </Field>
              </Column>
              {quote.duplicate &&
                <Column>
                  <Field>
                    <label className="label">Customer 1 Invoice Date</label>
                    <Control>
                      <Input
                        type="date"
                        name="customer1_invoice_date"
                        onChange={handleChange}
                        value={quote.customer1_invoice_date}
                      />
                    </Control>
                  </Field>
                </Column>
              }
              {quote.duplicate &&
                <Column>
                  <Field>
                    <label className="label">Customer 2 Invoice Date</label>
                    <Control>
                      <Input
                        type="date"
                        name="customer2_invoice_date"
                        onChange={handleChange}
                        value={quote.custome2_invoice_date}
                      />
                    </Control>
                  </Field>
                </Column>
              }
            </Columns>
            <Columns isMultiline>
              <Column>
                <Table isFullwidth>
                  <thead>
                  <th>Comment</th>
                  <th>Date Created</th>
                  <th>Creator</th>
                  <th>Remove</th>
                  </thead>
                  {quote.comments_list.map((value, index) => (
                    <Comment
                      key={value.id || value.key}
                      index={index}
                      comment={value}
                      updateComments={updateComment}
                      removeComment={removeComment}
                    />
                  ))}
                </Table>
                <Columns isMultiline>
                  <Column>
                    <Button
                      tabIndex={-1}
                      type="button"
                      color="info"
                      onClick={addComment}
                    >
                      Add Comment
                    </Button>
                  </Column>
                </Columns>
              </Column>
            </Columns>
          </form>
        </Box>
        <Box>
          <h1 className="title">Work</h1>
            <Box>
              <Columns isMultiline>
                <Column>
                  {quote.estimated_work_items
                      .filter(work => !work.added_after_quote)
                      .map((value, index) => (
                          <WorkSection
                              quote={quote}
                              key={value.id || value.key}
                              customer={quote.customer}
                              workTypes={workTypes}
                              workTypeObjects={workTypeObjects}
                              hireCustomer={quote.customer2}
                              vehicle={quote.vehicle}
                              index={index}
                              workItem={value}
                              update_work={updateWork}
                              remove_work_item={removeWorkItem}
                              onSearchPartClick={onSearchPartClick}
                              appDefaults={appDefaults}
                              additional={false}
                              disabled={quote.priced}
                          />
                      ))}
                </Column>
              </Columns>
              <Columns isMultiline>
                <Column>
                  <Button
                      id="add-workitem"
                      color="info"
                      onClick={addWorkItem}
                      disabled={quote.priced}
                  >
                    Add Work Item
                  </Button>
                  <Button
                      color="info"
                      style={{marginLeft: '10px'}}
                      onClick={() => {
                        setWorkModalState({...workModalState, modalOpen: true})
                      }}
                      disabled={quote.priced}
                  >
                    Search Work Lookups
                  </Button>
                </Column>
              </Columns>
            </Box>
          </Box>
        <Box>
          <h1 className="title">Work Added After Quote</h1>
          <Columns isMultiline>
            <Column>
              {quote.estimated_work_items
                  .filter(work => work.added_after_quote)
                  .map((value, index) => (
                      <WorkSection
                          quote={quote}
                          key={value.id || value.key}
                          customer={quote.customer}
                          hireCustomer={quote.customer2}
                          vehicle={quote.vehicle}
                          index={index}
                          workItem={value}
                          workTypes={workTypes}
                          workTypeObjects={workTypeObjects}
                          update_work={updateWork}
                          remove_work_item={removeWorkItem}
                          onSearchPartClick={onSearchPartClick}
                          appDefaults={appDefaults}
                          additional={true}
                          disabled={quote.priced}
                      />
                  ))}
            </Column>
          </Columns>
        </Box>
        {existingJobs &&
        <Box>
          <Columns isMultiline>
            <Column>
              <Title>Existing Jobs/Quotes</Title>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Table isFullwidth isBordered>
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Description</th>
                    <th>Customer</th>
                    <th>Workshop</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                {existingJobs.map(item => (
                    <tr>
                      <td className={"on-hover-highlight clickable"} onClick={() => onClick(item)}>{item.itemType}</td>
                      <td>{item.description || item.job_description}</td>
                      <td>
                        {item.itemType === "Job"
                            ? item.is_defect
                                ? null
                                : item.customer2
                                    ? item.customer2
                                    : item.customer
                                      ? item.customer
                                      : ""
                            :
                            item.customer2
                                ? item.customer2
                                : item.customer
                                      ? item.customer
                                      : ""
                        }
                      </td>
                      <td>
                        {item.workshop ? item.workshop.display_name : ""}
                      </td>
                      <td>{readableDate(item.itemType === 'Job' ? item.workshop_date : item.provisional_start_date)}</td>
                    </tr>
                ))}
                </tbody>
              </Table>
            </Column>
          </Columns>
          {quote.vehicle && quote.vehicle.id &&
            <Columns isMultiline>
              <Column>
                <Table isBordered isFullwidth>
                  <thead>
                    <tr>
                      <th>Inspection Type</th>
                      <th>Inspection Workshop</th>
                      <th>Expiry Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {quote.vehicle.inspections && quote.vehicle.inspections.map(inspection => (
                        <VehicleInspectionRow
                          inspection={inspection}
                          view={"popup"}
                        />
                    ))}
                  </tbody>
                </Table>
              </Column>
            </Columns>
          }
        </Box>
        }
        <Box>
          <Field>
            <div className="control">
              <Button onClick={handleSave} color="info" isFullWidth>
                Save Quote
              </Button>
            </div>
          </Field>
          <Field>
            <div className="control">
              <Button onClick={() => setImageModalOpen(true)} color="info" isFullWidth>
                {"Show Attached Images ("+images.length+")"}
              </Button>
            </div>
          </Field>
          <Field>
              <Button color="warning" onClick={handlePickListPrint} isFullWidth>
                Print Pick List
              </Button>
          </Field>
          {quote.id && (
              <Field>
                <Button
                    color="warning"
                    onClick={() => setPrintOptionsModalOpen(true)}
                    isFullWidth
                >
                  Print Workshop Quote Sheet
                </Button>
              </Field>
          )}
          {quote.id && (
              <Field>
                <div className="control">
                  <Button
                      onClick={() =>
                          setCreateJobModalState({
                            ...createJobCardModalState,
                            modalOpen: true
                          })
                      }
                      color="success"
                      isFullWidth
                  >
                    Create Job Card From Selected Items
                  </Button>
                </div>
              </Field>
          )}
          {quote.id && !quote.priced && (
              <Field>
                <div className="control">
                  <Button
                      onClick={() => {
                        triggerChange({priced: true})
                      }}
                      color="success"
                      isFullWidth
                  >
                    Quote Priced
                  </Button>
                </div>
              </Field>
          )}
          {quote.id && !quote.ready_for_customer_invoice && (
              <Field>
                <div className="control">
                  <Button
                      onClick={() => {
                        setApproveModalOpen(true);
                      }}
                      color="success"
                      isFullWidth
                  >
                    Approve for Invoicing
                  </Button>
                </div>
              </Field>
          )}
          {quote.id && (
              <Field>
                <Control>
                  <Button
                      onClick={() => {
                        setDeleteModalOpen(true);
                      }}
                      color="danger"
                      isFullWidth
                  >
                    Delete Quote
                  </Button>
                </Control>
              </Field>
          )}
        </Box>
        <PartSearchModal
            {...partsModalState}
            setModalState={setPartsModalState}
            selectPart={searchSelectPart}
        />
        <WorkSearchModal
            {...workModalState}
            setModalState={setWorkModalState}
            selectWork={searchSelectWork}
        />
        <CreateJobCardModal
            {...createJobCardModalState}
            setModalState={setCreateJobModalState}
            workItems={quote.estimated_work_items.filter(item => !item.job)}
            quote={quote}
            endpoint={props.endpoint}
            history={props.history}
        />
        <NotReadyForInvoiceModal
            open={notReadyModalOpen}
            setOpen={setNotReadyModalOpen}
            items={notReadyItems}
        />
        <DeleteWarningModal
            open={deleteModalOpen}
            setOpen={setDeleteModalOpen}
            onDelete={handleDelete}
        />
        <PrintOptionsModal
            open={printOptionsModalOpen}
            setOpen={setPrintOptionsModalOpen}
            data={quote}
        />
        <ApprovalModal
            open={approveModalOpen}
            setOpen={setApproveModalOpen}
            job={quote}
            workItems={quote.estimated_work_items.filter(item => item.not_being_done === false)}
            onApprove={handleApproveForInvoice}
            isJob={false}
        />
        <FinalizeModal
            open={finalizeModalOpen}
            setOpen={setFinalizeModalOpen}
            quote={quote}
            onFinalize={handleFinalize}
        />
        <ImageModal
          job={quote}
          open={imageModalOpen}
          setOpen={setImageModalOpen}
          dataFresh={dataFresh}
          type={'quote'}
          images={images}
          imagesLoaded={imagesLoaded}
        />
        <div style={{display: "none"}}>
          {!quote.enquiry_description &&
          <div ref={printPickListRef}>
            <PrintPickList data={quote}/>
          </div>
          }
        </div>
      </div>
    );
  } else {
    return <div>Loading...</div>;
  }
}

export default QuoteForm;
